import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { LoginComponent } from 'src/app/account/login/login.component';
import { UserProfile } from 'src/app/shared-core/models/auth-data.model';
import { MessageTopicsEnum } from 'src/app/shared-core/models/component-message.model';
import { AuthService } from 'src/app/shared-core/services/auth.service';
import { CartService } from 'src/app/shared-core/services/cart.service';
import { ComponentMessagingService } from 'src/app/shared-core/services/component-messaging.service';

@Component({
  selector: 'app-cart-layout',
  templateUrl: './cart-layout.component.html',
  styleUrls: ['./cart-layout.component.scss'],
})
export class CartLayoutComponent implements OnInit {
  VistekUrl: string;
  userProfile: UserProfile = null;
  isAuthenticated: boolean = false;
  public year = new Date().getFullYear();

  @ViewChild('loginModal') loginModal: LoginComponent;

  constructor(
    private cartService: CartService,
    private authService: AuthService,
    private toaster: ToastService,
    private messaging: ComponentMessagingService
  ) {
    this.VistekUrl = this.cartService.VistekUrl;
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.authService.UserProfileSubject.subscribe((user) => {
      this.userProfile = user;
      this.isAuthenticated = !!user;
    });
    this.messaging.onMessage().subscribe((msg) => {
      if (msg.topic == MessageTopicsEnum.Login) {
        this.loginModal.show = 'login';
      }
    });
  }

  logout() {
    this.authService.logout().subscribe((data) => {
      this.toaster.success('Logged out successfully.');
      window.location.reload();
    });
  }

  getUserProfile() {
    this.authService.getUserProfile().subscribe();
  }
}
